import { ValidationState, FormValidation } from '../types';
import { FormData } from '../services/SecureApiService';

export const createInitialValidation = (): FormValidation => ({
  firstName: { isValid: false, error: "", touched: false },
  lastName: { isValid: false, error: "", touched: false },
  email: { isValid: false, error: "", touched: false },
  company: { isValid: true, error: "", touched: false },
  service: { isValid: false, error: "", touched: false },
  message: { isValid: false, error: "", touched: false },
});

export const validateField = (
  name: keyof FormData,
  value: string
): ValidationState => {
  let isValid = true;
  let error = "";

  switch (name) {
    case "firstName":
    case "lastName":
      if (!value.trim()) {
        isValid = false;
        error = `${name === "firstName" ? "First" : "Last"} name is required`;
      } else if (value.trim().length < 2) {
        isValid = false;
        error = `${
          name === "firstName" ? "First" : "Last"
        } name must be at least 2 characters`;
      } else if (!/^[a-zA-Z\s\-'.]+$/.test(value.trim())) {
        isValid = false;
        error = `${
          name === "firstName" ? "First" : "Last"
        } name contains invalid characters`;
      }
      break;

    case "email":
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value.trim()) {
        isValid = false;
        error = "Email is required";
      } else if (!emailRegex.test(value.trim())) {
        isValid = false;
        error = "Please enter a valid email address";
      }
      break;

    case "company":
      if (value.trim() && /<[^>]*>/.test(value)) {
        isValid = false;
        error = "Company name contains invalid characters";
      }
      break;

    case "service":
      if (!value) {
        isValid = false;
        error = "Please select a service or product";
      }
      break;

    case "message":
      if (!value.trim()) {
        isValid = false;
        error = "Message is required";
      } else if (value.trim().length < 10) {
        isValid = false;
        error = "Message must be at least 10 characters";
      } else if (value.trim().length > 1000) {
        isValid = false;
        error = "Message must be less than 1000 characters";
      }
      break;
  }

  return { isValid, error, touched: true };
};